import { OrganizationPreviewResponseDto } from "./persons";
import { SalePreviewResponseDto } from "./sales";
import { UserSelectableEntityResponseDto } from "./users";

export interface CreateDealRequestDto {
  title: string;
  belongsToPipelineId: string;
  information?: string;
}

export interface DealKanbanStageCreateRequestDto {
  title: string;
  sort: number;
}

export interface DealResponseDto {
  _id: string;
  title: string;
  belongsToPipelineId?: string;
  belongsToStageId?: string;
  belongsToPersonId: string;
  belongsToOrganizationId?: string;
  information?: string;
  createdAt: string;
  updatedAt: string;
}

export interface DealSummaryPreviewElementResponseDto {
  _id: string;
  title: string;
}

export interface DealSummaryPreviewResponseDto {
  organizationSummary?: DealSummaryPreviewElementResponseDto;
  personSummary?: DealSummaryPreviewElementResponseDto;
}

export interface DealKanbanResponseDto {
  _id: string;
  title: string;
  summary: DealSummaryPreviewResponseDto;
  createdAt: string;
  isEditable: boolean;
  belongsToUserFullName: string;
}

export interface DealKanbanStageListResponseDto {
  _id: string;
  title: string;
  sort: number;
  deals: DealKanbanResponseDto[];
}

export interface DealSelectableEntitiesResponseDto {
  pipelines: DealsPipelineSelectableEntityResponseDto[];
}

export interface DealsPipelineSelectableEntityResponseDto {
  _id: string;
  value: string;
}

export interface DealKanbanBoardResponseDtoWithSelectableEntities {
  _id: string;
  title: string;
  stages: DealKanbanStageListResponseDto[];
  selectableEntities: DealSelectableEntitiesResponseDto;
  selectedPipelineId: string;
}

export interface DealKanbanBoardResponseDto {
  _id: string;
  title: string;
  stages: DealKanbanStageListResponseDto[];
}

export interface PersonPreviewResponseDto {
  _id: string;
  fullName: string;
  firstName: string;
  lastName: string;
  mail: string;
  phone: string;
  postalCode: string;
  city: string;
  street: string;
  country: string;
}

export interface DealDetailsResponseDto {
  _id: string;
  title: string;
  isEditable: boolean;
  belongsToPersonId?: string;
  belongsToOrganizationId?: string;
  information?: string;
  pipelineTitle?: string;
  belongsToUserId?: string;
  belongsToUserFullName?: string;
  belongsToPipelineId?: string;
  stageTitle?: string;
  summaryPreview?: DealSummaryPreviewResponseDto;
  personPreview?: PersonPreviewResponseDto;
  organizationPreview?: OrganizationPreviewResponseDto;
  salePreview?: SalePreviewResponseDto;
  selectableEntities?: DealDetailsSelectableEntitiesResponseDto;
  isArchived: boolean;
  isWon: boolean;
}

export interface DealDetailsSelectableEntitiesResponseDto {
  users: UserSelectableEntityResponseDto[];
}

export interface UpdateDealRequestDto {
  title: string;
  belongsToPersonId?: string;
  belongsToOrganizationId?: string;
  information?: string;
}

export interface UpdateDealStageRequestDto {
  belongsToStageId: string;
}

export interface DealsCreationEntitiesResponseDto {
  pipelines: DealsPipelineSelectableEntityResponseDto[];
}

// {
//   "_id": "123",
//     "createdAt": "2025-03-20T13:15:01.433Z",
//       "type": "history-note",
//         "belongsToUserId": "123",
//           "belongsToUserFullName": "John Doe",
//             "historyNoteContent": {
//     "_id": "123",
//       "description": "This is a note"
//   }
// }

export interface DealHistoryResponseDto {
  _id: string;
  belongsToUserId: string;
  type: DealHistoryType;
  createdAt: string;
  belongsToUserFullName: string;
  historyNoteContent: {
    _id: string;
    description: string;
  };
}

export enum DealHistoryType {
  HISTORY_NOTE = "history-note",
  ACTIVITY = "activity",
  NOTE = "note",
}

export interface CreateNoteRequestDto {
  description: string;
}
